<template>
  <el-dialog
    custom-class="warning-dialog"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
    :modal="false"
    v-model="visible"
    :draggable="true"
    :width="styleConfig.width ? parseInt(styleConfig.width.replace('px', '')) + 38 : 600"
    :style="styleConfig"
  >
    <template #header>
      <div flex="dir:left main:justify">
        <h2 style="color: #333">{{ title }}</h2>
        <el-icon class="detail-close" @click="visible = false"><Close /></el-icon>
      </div>
    </template>
    <div class="early-warning-detail">
      <div
        class="detail-content custom-scrollbar"
        v-html="text"
        :style="{
          ...contentStyle,
        }"
      ></div>
    </div>
  </el-dialog>
</template>

<script lang="ts" setup>
import { ref, defineExpose } from "vue"
import { ElDialog } from "element-plus"
import { debounce } from "lodash-es"

const title = ref<string>("")
const text = ref<string>("")
const styleConfig = ref<any>({})
const contentStyle = ref<any>({})
const visible = ref<boolean>(false)

const finalShow = debounce((titleTxt: string, detailText: string, style: any, content: any) => {
  // console.log('show come in', titleTxt, detailText, style, content);
  title.value = titleTxt
  text.value = detailText
  styleConfig.value = style
  contentStyle.value = content
  visible.value = true
}, 500)

function show(titleTxt: string, detailText: string, style: any, content: any) {
  // console.log('show come in', titleTxt, detailText, style, content);
  finalShow(titleTxt, detailText, style, content)
}

defineExpose({
  show,
})
</script>

<style lang="scss">
//自定义滚动条scrollbar
.custom-scrollbar,
.custom-scrollbar .el-table__body-wrapper {
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-webkit-scrollbar-corner {
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-webkit-scrollbar-resizer {
    background-color: #ff6e00;
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-o-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-o-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-o-scrollbar-corner {
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-o-scrollbar-resizer {
    background-color: #ff6e00;
  }

  &::-o-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-moz-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-moz-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-moz-scrollbar-corner {
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-moz-scrollbar-resizer {
    background-color: #ff6e00;
  }

  &::-moz-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-ms-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-ms-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-ms-scrollbar-corner {
    background-color: rgba(0, 0, 0, 0.12);
  }

  &::-ms-scrollbar-resizer {
    background-color: #ff6e00;
  }

  &::-ms-scrollbar {
    width: 8px;
    height: 8px;
  }
}

.scroll::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 12px;
}

.scroll::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
  background: #fff;
}

.scroll::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  background: #888;
}

.early-warning-detail {
  color: inherit;

  .detail-content {
    overflow-y: auto;
  }

  .detail-close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  .detail-close:hover {
    opacity: 0.5;
  }
}

.warning-dialog .el-dialog__body {
  padding: 0;
  box-sizing: border-box;
}

.warning-dialog .el-dialog__header i.el-dialog__close {
  color: #000;
  font-weight: bold;
}
</style>
